class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.miniCartWrapper = document.querySelector(".icon__wrapper");
    this.miniCarOverlay = document.querySelector(".mini-cart__overlay");
    this.showCart();
    this.hideCart();
    this.miniCartList = this.querySelector(".mini-cart");
    this.updateMiniCart();

    this.previousCartData = null;

    this.miniCartList.addEventListener(
      "click",
      this.handleButtonClick.bind(this)
    );
  }

  showCart() {
    const isSmallScreen = window.innerWidth > 750;

    this.miniCartWrapper.addEventListener("mouseenter", () => {
    if (isSmallScreen) {
      this.miniCartWrapper.classList.add("show");
    }
      this.updateMiniCart();
    });
  }

  hideCart() {
    this.miniCartWrapper.addEventListener("mouseleave", () => {
      this.miniCartWrapper.classList.remove("show");
    });
  }

  handleButtonClick(event) {
    const isSmallScreen = window.innerWidth < 750;

    if (
      event.target.matches("#decrease-quantity") ||
      event.target.matches("#increase-quantity")
    ) {
      const form = event.target.closest(".mini-cart-form");
      const quantityInput = form.querySelector(".m-quantity");
      const itemLine = parseInt(form.dataset.itemLine);
      let currentValue = parseInt(quantityInput.value);
      this.miniCarOverlay.classList.add("show");

      if (event.target.matches("#decrease-quantity")) {
        if (currentValue > 0) {
          this.updateQuantity(currentValue - 1, itemLine);
        } else {
          this.removeItem(itemLine);
        }
      } else if (event.target.matches("#increase-quantity")) {
        if (currentValue < 99) {
          this.updateQuantity(currentValue + 1, itemLine);
        }
      }
    } else if (event.target.closest(".mini-cart__remove")) {
      const itemLine = parseInt(event.target.closest("form").dataset.itemLine);
      this.removeItem(itemLine);
    }
  }

  updateQuantity(quantity, itemLine) {
    const formatData = {
      line: itemLine,
      quantity: quantity,
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formatData),
    })
      .then((response) => response.json())
      .then((data) => {
        this.updateMiniCart(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  removeItem(itemLine) {
    const formatData = {
      line: itemLine,
      quantity: 0,
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formatData),
    })
      .then((response) => response.json())
      .then((data) => {
        this.updateMiniCart(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  updateMiniCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountBubble = document.querySelector(".cart-count-bubble");
        const subtotal = document.querySelector(".mini-cart__subtotal-amount");

        if (JSON.stringify(this.previousCartData) !== JSON.stringify(cart)) {
          this.previousCartData = cart;
          cartCountBubble.innerText = cart.item_count;
          subtotal.innerText = Shopify.formatMoney(cart.items_subtotal_price);
          this.miniCartList.innerHTML = "";

          if (cart.item_count === 0) {
            this.miniCartList.innerHTML =
              "<li class='empty-cart-message'><h5>Cart is empty</h5></li>";
            return;
          }

          cart.items.forEach((item, index) => {
            const itemHTML = `
              <li class="mini-cart__item">
                <div class="mini-cart__image-wrapper">
                  <img src="${item.image}" width="50" height="50" alt="${
              item.title
            }">
                </div>
                <ul class="mini-cart__details">
                  <li class="mini-cart__line-title">${item.title}</li>
                  <li class="mini-cart__line-price f-bold">${Shopify.formatMoney(
                    item.line_price
                  )}</li>
                  <li>
                    <form class="mini-cart-form" data-item-line="${index + 1}">
                      <div class="quantity-controls">
                        <button type="button" class="mini-cart__control" id="decrease-quantity">-</button>
                        <input class="mini-cart__control m-quantity" id="product-quantity" value="${
                          item.quantity
                        }" min="0">
                        <button type="button" class="mini-cart__control" id="increase-quantity">+</button>
                      </div>
                      <span class="mini-cart__remove">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                      </span>
                    </form>
                  </li>
                </ul>
              </li>
            `;
            this.miniCartList.innerHTML += itemHTML;
          });
        }

        this.miniCarOverlay.classList.remove("show");
      })
      .catch((error) => {
        console.error("Error fetching cart count:", error);
      });
  }
}

customElements.define("mini-cart", MiniCart);
